var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.message.content.isRoutine
        ? _c("routine-list", {
            staticClass: "products-message message",
            attrs: { message: _vm.message },
            on: {
              "product-clicked": _vm.handleProductClickedEvent,
              "product-added-to-cart": _vm.handleAddedToCartEvent,
              "product-routine-added-to-cart":
                _vm.handleRoutineAddedToCartEvent,
              "attribute-matching-list-expanded":
                _vm.handleAttributeMatchingListExpandedEvent,
              "product-info-clicked": _vm.handleProductInfoClickedEvent,
            },
          })
        : _c("products-list", {
            staticClass: "products-message message",
            attrs: { message: _vm.message },
            on: {
              "product-clicked": _vm.handleProductClickedEvent,
              "product-added-to-cart": _vm.handleAddedToCartEvent,
              "attribute-matching-list-expanded":
                _vm.handleAttributeMatchingListExpandedEvent,
              "product-info-clicked": _vm.handleProductInfoClickedEvent,
            },
          }),
      _vm._v(" "),
      _vm.isShowingMoreProducts
        ? _c("div", { staticClass: "more-products-panel" }, [
            _c(
              "button",
              {
                staticClass: "quick-reply-button",
                attrs: { type: "button" },
                on: { click: _vm.handleMoreProductsClicked },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.moreProductsButtonTitle) + "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }